<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ title }}</h5>
              <slot name="control"></slot>
            </div>
            <div class="modal-body">
              <slot></slot>
            </div>
            <div class="modal-footer justify-content-between">
              <slot name="footer"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>  
</template>

<script>
export default {
  name: "PopupBox",
  setup() {
    
  },
  props: [
    "title"
  ],
  methods: {

  }
}
</script>